import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_palletspace-preview/artifacts/blymwoyp_LOGO1.png" 
              alt="PalletSpace.uk" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              Flexible and scalable pallet storage solutions designed to adapt to your business needs.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-slate-400 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/" 
                  className="text-slate-300 hover:text-orange-500 transition-colors"
                  data-testid="footer-home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/prices" 
                  className="text-slate-300 hover:text-orange-500 transition-colors"
                  data-testid="footer-prices"
                >
                  Prices
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-slate-300 hover:text-orange-500 transition-colors"
                  data-testid="footer-contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-slate-400 mb-4">
              Contact Us
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-slate-300">
                <MapPin size={18} className="text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  Units 1, 2 & 3 Plantation Road<br />
                  Burscough Industrial Estate<br />
                  Burscough, Lancashire L40 8JT
                </span>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <Phone size={18} className="text-orange-500 flex-shrink-0" />
                <a 
                  href="tel:01704332544" 
                  className="text-sm hover:text-orange-500 transition-colors"
                >
                  01704 332544
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <Mail size={18} className="text-orange-500 flex-shrink-0" />
                <a 
                  href="mailto:info@palletspace.uk" 
                  className="text-sm hover:text-orange-500 transition-colors"
                >
                  info@palletspace.uk
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} PalletSpace.uk. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
